enum AnnotationLineFunctionFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	COLOR = "color",
	OPACITY = "opacity",
	STROKE = "stroke",
	STYLE = "style",
}

export default AnnotationLineFunctionFields;